import getRootState from './rootStateSelector';

export const getAuthState = (state) => getRootState(state).get('auth');

export const getIsCheckingAuth = (state) =>
  getAuthState(state).get('isAuthenticated') === null;

export const getIsAuthLoading = (state) => getAuthState(state).get('isLoading');

export const getIsNotLoggedIn = (state) => {
  const authState = getAuthState(state);
  const isAuthenticated = authState ? authState.get('isAuthenticated') : null;
  // if isAuthenticated is FALSE or NULL, return TRUE -- show the logged out experience
  //   -- NULL means the authentation check is still pending
  //   -- while pending, we may not have the data to render the logged in experience
  return !isAuthenticated;
};
